import React from 'react';
import { Radio } from '@domain-group/fe-blueprint-ui/form';
import {
  AGENCY_VIEW,
  AGENT_VIEW,
  SEARCH_TYPE_OPTIONS,
} from '../search-filter-bar/enums';
import * as styles from './search-type-toggle.style';

interface SearchTypeToggleProps {
  isAgency: boolean;
  onSelect: (view: string) => void;
}

const GROUP_NAME = 'search-type';

const SearchTypeToggle = ({
  isAgency,
  onSelect,
}: SearchTypeToggleProps): JSX.Element => {
  const current = isAgency ? AGENCY_VIEW : AGENT_VIEW;

  return (
    <div
      css={styles.group}
      role="radiogroup"
      aria-label="Search for"
      data-testid="search-type-toggle"
    >
      {SEARCH_TYPE_OPTIONS.map(({ value, label }) => (
        <Radio
          key={value}
          isTile
          tileAppearance="segment"
          size="small"
          id={`${GROUP_NAME}-${value}`}
          name={GROUP_NAME}
          value={value}
          labelContent={label}
          checked={value === current}
          onChange={() => onSelect(value)}
        />
      ))}
    </div>
  );
};

export default SearchTypeToggle;
